<template>
  <div>
    <b-row class="text-left">
      <b-col></b-col>
      <b-col cols="10">
        <LoadingIndicator 
          v-if="loadingProject"
          topic="Action Items"
        />
        <div v-else-if="project != null">
          <b-row>
            <b-col>
              <div>
                <ProjectMetricList
                  :projectMetrics="openProjectMetrics"
                  :projectId="project.projectId"
                  :title="'Open Action Items'"
                  :action="'Edit'"
                  :possibleAssignees="users"
                  :presetTags="project.presetTags"
                  @update="loadProjectMetrics(project.projectId)"
                />
              </div>
            </b-col>
            <b-col cols="12" lg="6">
              <div>
                <ProjectMetricList
                  :projectMetrics="closedProjectMetrics"
                  :projectId="project.projectId"
                  :title="'Closed Action Items'"
                  :action="'Edit'"
                  :possibleAssignees="users"
                  :presetTags="project.presetTags"
                  @update="loadProjectMetrics(project.projectId)"
                />
              </div>
            </b-col>
          </b-row>
        </div>
        <BaseMessageBlock :messages="errors"></BaseMessageBlock>
      </b-col>
      <b-col></b-col>
    </b-row>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import ProjectMetricList from "@/components/project/ProjectMetricList.vue";
import ProjectActionBar from "@/sub-components/ProjectActionBar.vue";

export default {
  components: {
    ProjectMetricList,
    ProjectActionBar
  },
  props: {
    projectSummary: { type: Object, required: true }
  },
  data() {
    return {
      errors: [],
      loadingProject: false,
      loadingProjectMetrics: false,
      projectMetrics: [],
      users: [],
      project: null
    }
  },
  computed: {
    ...mapGetters({
      isLoading: 'getDataLoading',
      hasLoaded: 'getDataLoaded',
    }),
    openProjectMetrics() {
      return this.projectMetrics.filter(a => a.status === "Open");
    },
    closedProjectMetrics() {
      return this.projectMetrics.filter(a => a.status === "Closed");
    }
  },
  watch: {

  },
  mounted() {
    if (!this.isSystemAdmin) {
      this.defaultRedirect();
    }
    let projectId = this.$route.params.id;
    this.loadProject(projectId);
  },
  methods: {
    loadProject(projectId) {
      this.loadingProject = true;
      axios
        .get(`${this.$api_url}/projects/${projectId}`, this.getReqConfig())
        .then(response => {
          this.project = response.data;
          this.loadProjectMetrics(projectId);
          this.loadProjectUsers(projectId);
        })
        .catch(err => {
          this.errors.push(...this.$helpers.formatErrors(err));
        })
        .finally(() => {
          this.loadingProject = false;
        });
    },
    loadProjectMetrics(projectId) {
      this.loadingProjectMetrics = true;
      axios
        .get(`${this.$api_url}/projects/${projectId}/project-metrics`, this.getReqConfig())
        .then(response => {
          this.projectMetrics = response.data;
        })
        .catch(err => {
          this.errors.push(...this.$helpers.formatErrors(err));
        })
        .finally(() => {
          this.loadingProjectMetrics = false;
        });
    },
    loadProjectUsers(projectId) {
      this.loadingProjectUsers = true;
      axios
        .get(`${this.$api_url}/projects/${projectId}/users`,
          this.getReqConfig())
        .then(response => {
          this.users = response.data;
        })
        .catch(err => {
          this.errors.push(err);
        })
        .finally(() => {
          this.loadingProjectUsers = false;
        });
    },
  }
}
</script>

<style lang="scss" scoped>
  .surveyTitle {
    font-size: 1.75em;
    line-height: 1em;
    color: #555;
  }
</style>
